import React from 'react';
import { useLocation } from 'react-router-dom';
import StaticShell from '../Static/StaticShell';
import { regionFromPathname } from '../../utils/regionFromPath';
import { useI18n } from '../../hooks/useI18n';
import SEO from '../../components/seo/SEO';
import ManagedInlineBanner from '../../components/ads/ManagedInlineBanner';
import { bannerAds } from '../../data/staticAds';

export default function TermsPage() {
  const region = regionFromPathname(useLocation().pathname);
  const { t } = useI18n();
  return (
    <>
      <SEO
        region={region}
        path="/terms"
        title={t('static.terms.title', 'Terms of service')}
        description={t('static.terms.p1', 'Terms for votes, suggestions and content attribution.')}
      />
      <StaticShell title={t('static.terms.title', 'Terms of service')} region={region}>
        <>
          <p>{t('static.terms.p1', 'Terms for using FliqMatch and community features.')}</p>
          <p style={{ marginTop: '1rem' }}>
            {t(
              'static.terms.p2',
              'Sponsored listings may appear on the site. Measurement of those placements is described in our privacy policy.',
            )}
          </p>
          <div style={{ marginTop: '2rem' }}>
            <ManagedInlineBanner pageKey="legal" fallbackAd={bannerAds[1] ?? bannerAds[0]} variant="inline" />
          </div>
        </>
      </StaticShell>
    </>
  );
}
